import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";
import {FigmaTemplate} from "@/includes/fig-parser/models/figma-template";
import {FigmaElement} from "@/includes/fig-parser/models/base/figma-element";

export class FigmaCanvas extends FigmaElement {
  type = FIG_PARSED_FIELD_TYPES.CANVAS;

  /**
   * @type {FigmaTemplate[]}
   */
  children;

  constructor(data) {
    super(data);
    
    this.children = this._mapChildren(data.children);
  }

  _mapChildren(children) {
    return children
      .filter(child => child.type === FIG_PARSED_FIELD_TYPES.TEMPLATE)
      .map(child => new FigmaTemplate(child));
  }
}
